import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Chip } from "@mui/material";
import Form from "react-bootstrap/Form";
import Swal from "sweetalert2";
import * as constants from "../constants";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function GroupCreateModal({
  open,
  handleClose,
  handleOwnGroup,
  handleMyGroup,
}) {
  const [fullWidth] = React.useState(true);
  const [maxWidth] = React.useState("sm");

  const [name, setName] = React.useState("");
  const [about, setAbout] = React.useState("");

  const [openAlt, setOpenAlt] = React.useState(false);

  const handleClick = () => {
    setOpenAlt(true);
  };

  const handleAltClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenAlt(false);
  };

  const baseURL = constants.BASE_URL;

  const handleGroup = () => {
    if (!name) {
      handleClick();
      return;
    }

    const newData = new FormData();
    newData.append("name", name);
    newData.append("about", about);
    // newData.append("cover_pic", coverPic);
    // newData.append("profile_pic", profilePic);

    fetch(`${baseURL}/group/create/`, {
      method: "POST",
      headers: {
        Authorization: `Token ${localStorage.getItem("auth_token")}`,
      },
      body: newData,
    })
      .then((res) => {
        res.json();
        if (res.status === 201) {
          handleClose();
          handleOwnGroup();
          Swal.fire({
            title: "Congratulation!",
            text: "You'Ve Successfully Create the Group",
            imageUrl: "https://i.ibb.co/S32wFXM/congress.jpg",
            imageWidth: 350,
            imageHeight: 200,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Yes!",
          });
        }
        setName("");
        setAbout("");
      })
      .catch((error) => alert(error));
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={open}
        onClose={handleClose}
      >
        <DialogTitle className="text-center fw-bold">Create Group</DialogTitle>
        <Form onSubmit={handleGroup}>
          <DialogContent>
            <Form.Label>Group Name</Form.Label>
            <Form.Control
              style={{
                backgroundColor: "#C1CDF9",
              }}
              className="rounded-4 mb-2"
              type="text"
              onChange={(e) => setName(e.target.value)}
              value={name}
              required
            />
            <Form.Group className="mb-3">
              <Form.Label>Group About</Form.Label>
              <Form.Control
                style={{
                  backgroundColor: "#C1CDF9",
                }}
                className="rounded-4"
                as="textarea"
                onChange={(e) => setAbout(e.target.value)}
                value={about}
                rows={3}
              />
            </Form.Group>
          </DialogContent>
          <DialogActions>
            <Chip onClick={handleClose} label="Cancel" color="error" />
            <Chip onClick={() => handleGroup()} label="Save" color="primary" />
          </DialogActions>
        </Form>
      </Dialog>
      <Snackbar open={openAlt} autoHideDuration={6000} onClose={handleAltClose}>
        <Alert severity="error">Group Name is required</Alert>
      </Snackbar>
    </React.Fragment>
  );
}
